
import { Component, Prop, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import { WPXFormValue } from '@/components/templates/WPXForm';
import { CreateDatabaseForm } from '@/services/Database/forms/CreateDatabaseForm';
import { DatabaseRepositoryInterface } from '@/services/Database/interfaces';
import { ServerInterface, ServerRepositoryInterface } from '@/services/Server/Interfaces';
import { Website } from '@/services/Website/interfaces';

@Component({
  mixins: [Themeable],
  inject: [
    'databaseRepository',
    'serverRepository',
  ],
})
export default class CreateDatabaseDialog extends Vue {
  @Prop({ required: true }) private readonly website!: Website;

  private form: WPXFormValue<CreateDatabaseForm> = new WPXFormValue(CreateDatabaseForm);
  private databaseRepository!: DatabaseRepositoryInterface;
  private serverRepository!: ServerRepositoryInterface;

  private visible: boolean = true;
  private loading: boolean = true;
  private servers: ServerInterface[] = [];

  public async created(): Promise<void> {
    try {
      this.servers = await this.serverRepository.getAllServers();
      this.form.data.websiteId = this.website.id;
      this.form.data.server = this.website.originServer;
    } catch (e) {
      this.$errorDialog.show(e.response?.data?.message || e.message);
    } finally {
      this.loading = false;
    }
  }

  private async createDatabase(): Promise<void> {
    try {
      const database = await this.databaseRepository.createDatabase({
        name: this.form.data.name,
        password: this.form.data.password,
        passwordConf: this.form.data.passwordConf,
        server: this.form.data.server,
        websiteId: this.website.id,
      });
      this.$successDialog.show('Database Created Successfully!');
      this.$emit('created', database);
      this.close();
    } catch (e) {
      this.$errorDialog.show(e.response?.data?.message || e.message);
    }
  }

  private close(): void {
    this.visible = false;
    this.$emit('close');
  }
}
